export function calculateRealtimeWpm(cursorPosition: number, elapsedMs: number): number {
  if (cursorPosition <= 0 || elapsedMs <= 0) return 0;
  return Math.floor(cursorPosition / (elapsedMs / 60000));
}
